import { render } from "./PerformanceSnapshotBar.vue?vue&type=template&id=736b01cf&scoped=true"
import script from "./PerformanceSnapshotBar.vue?vue&type=script&lang=js"
export * from "./PerformanceSnapshotBar.vue?vue&type=script&lang=js"

import "./PerformanceSnapshotBar.vue?vue&type=style&index=0&id=736b01cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736b01cf"]])

export default __exports__